export const Hourglass = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 12L6.67189 8.59001C6.09749 8.2224 5.75 7.58743 5.75 6.90547V2.75H18.25V6.90547C18.25 7.58743 17.9025 8.2224 17.3281 8.59001L12 12ZM12 12L17.3281 15.41C17.9025 15.7776 18.25 16.4126 18.25 17.0945V21.25H5.75V17.0945C5.75 16.4126 6.09749 15.7776 6.67189 15.41L12 12ZM20.25 21.25H3.75M20.25 2.75H3.75" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>

  )
}